<script>
import { mapState, mapActions } from "vuex";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import dateMixin from "@/mixins/dateMixin";
import notificationMixin from "@/mixins/notificationMixin";
import IconTooltip from "@/components/_Shared/Users/Status/IconTooltip";

export default {
  title: "Notifications",
  mixins: [dateMixin, notificationMixin],

  components: {
    IconTooltip
  },

  data() {
    return {
      headers: [
        { text: "Status", value: "status", sortable: false },
        { text: "Agendada para", value: "scheduled_time", align: "center" },
        { text: "Titulo", value: "title", align: "center", sortable: false },
        {
          text: "Mensagem",
          value: "message",
          align: "center",
          sortable: false
        },
        { value: "data-table-expand" }
      ]
    };
  },

  computed: {
    ...mapState("notifications", [
      "items",
      "footerProps",
      "options",
      "loader",
      "search",
      "notificationType",
      "totalItems",
      "items"
    ]),

    options: {
      get() {
        return this.$store.state.notifications.options;
      },
      set(value) {
        this.$store.dispatch("notifications/setOptions", value);
      }
    }
  },
  methods: {
    ...mapActions("notifications", ["listAll"])
  },

  watch: {
    options: {
      handler() {
        this.listAll();
      },
      deep: true
    }
  },

  mounted() {
    if (this.notificationType == "scheduled") this.listAll();
  }
};
</script>

<template>
  <div>
    <transition name="fade" mode="out-in">
      <v-card class="mb-20 px-4" flat>
        <v-divider></v-divider>

        <v-data-table
          :headers="headers"
          :items="items"
          class="elevation-1"
          show-expand
          :server-items-length="totalItems"
          :footer-props="footerProps"
          :options.sync="options"
          :loading="loader"
        >
          <template v-slot:item.status="{ item }">
            <icon-tooltip :options="getStatus(item.status)" />
          </template>

          <template v-slot:item.scheduled_time="{ item }">
            <v-chip small outlined>{{
              item.scheduled_time | dateAndTime
            }}</v-chip>
          </template>

          <template v-slot:item.title="{ item }">
            <v-chip small outlined>{{
              item.title | formatTitle("title")
            }}</v-chip>
          </template>

          <template v-slot:item.message="{ item }">
            <v-chip small outlined>{{
              item.title | formatMessage("title")
            }}</v-chip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <p class="mt-5">
                <b>ID:</b>
                {{ item.id }}
              </p>
              <p>
                <b>TITULO:</b>
                {{ item.title }}
              </p>
              <p>
                <b>MENSAGEM:</b>
                {{ item.message }}
              </p>
              <p>
                <b>STATUS:</b>
                {{ item.status | getNotificationStatus("name") }}
              </p>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </transition>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/List/Scheduled.vue